import { timestamp, uuid } from "@/interfaces";
import { organization_type } from "@/models/organization.model.ts";

export enum ChatRoomType {
  direct = "direct",
  appointment = "appointment",
  daily_work = "daily_work",
}

export interface ChatRoom {
  id: uuid;
  appointment: uuid | null;
  daily_work: uuid | null;
  type: ChatRoomType;
  users: uuid[];
  updated_at: timestamp;

  unread_count?: number;
  last_message_data?: ChatRoomMessage[];
  appointment_data?: {
    id: uuid;
    status: string;
    date: string;
    property: { name: string };
    unit: { unit_number: string };
    service: { id: uuid; name: string };
    vendor: { id: uuid; display_name: string };
  };
  daily_work_data?: {
    id: uuid;
    property?: {
      id: uuid;
      name: string;
    };
  };
}

export interface ChatRoomUser {
  id: uuid;
  room: uuid;
  user: uuid;
  count: number;
  last_read_at: timestamp;
  role?: string;
  joined_at?: timestamp;
  created_at: timestamp;
  updated_at: timestamp;
}

// TODO: All actions, etc
interface RescheduleAction {
  action: "reschedule";
  old_date: timestamp;
  new_date: timestamp;
}

interface FileMeta {
  url: string;
  name: string;
  mime: string;
  size: number;
  width?: number;
  height?: number;
}

interface AppointmentLinkMeta {
  appointmentId: uuid;
  propertyName: string;
  unitNumber: string;
  date: string;
  serviceName: string;
  vendorName: string;
}

interface SystemMessageMeta {
  systemMessageType: string;
  appointmentId: uuid;
  appointmentLink?: AppointmentLinkMeta;
}

interface ApprovalProcessingMeta {
  processed: boolean;
  approved?: boolean;
  processedBy?: uuid;
  processedByName?: string;
  processedAt?: timestamp;
}

export type ChatRoomMessageMetaData =
  | RescheduleAction
  | { file: FileMeta }
  | SystemMessageMeta
  | ApprovalProcessingMeta
  | any;

export type ChatRoomFileType = "image" | "document" | "audio" | "video" | "other" | null;

export interface ChatRoomMessage {
  id: uuid;
  sender: uuid;
  room: uuid;
  message: string;
  is_file: boolean;
  file_type: ChatRoomFileType | null;
  is_system: boolean;
  meta_data: ChatRoomMessageMetaData;
  created_at: timestamp;
  updated_at: timestamp;
}

export interface Contact {
  id: uuid;
  name: string;
  avatar?: string | null;
  organizationId: uuid;
  organizationName: string;
  organizationType: organization_type;
}
